export const MAXIMUM_LENGTH_INVOICE_NUMBER = 20;
export const MAXIMUM_LENGTH_INFO = 500;
export const MAXIMUM_LENGTH_NUMBER = 12;
export const MAXIMUM_LENGTH_NUMBER_FOR_NEGATIVE_AMOUNTS = 13
export const MAXIMUM_LENGTH_TEXTAREA = 1000
export const MAXIMUM_LENGTH_INPUT_SELECT = 200
export const MAXIMUM_LENGTH_LONG_TEXTAREA = 2000
export const MAXIMUM_LENGTH_TAX_ID = 13
export const MINIMUM_FRACTION_DIGITS = 0
export const MAXIMUM_FRACTION_DIGITS = 2